export function personName(person) {
  return person?.displayName || 'Member'
}

export function period(entry) {
  if (!entry) return ''
  const start = entry.startYear || ''
  const end = entry.current ? 'Present' : entry.endYear || ''
  if (start && end) return `${start}–${end}`
  return String(start || end || '')
}

export function relationLabel(relation) {
  if (relation === 'connected') return 'Connected'
  if (relation === 'outgoing') return 'Requested'
  if (relation === 'incoming') return 'Request'
  if (relation === 'self') return 'You'
  return ''
}
